import React from 'react';
import { Home, ListChecks, ScanLine, User } from 'lucide-react';
import type { OfficerScreen } from '../../types/officer';
const items: {
  id: OfficerScreen;
  label: string;
  icon: typeof Home;
}[] = [{
  id: 'home',
  label: 'হোম',
  icon: Home
}, {
  id: 'camera',
  label: 'স্ক্যান',
  icon: ScanLine
}, {
  id: 'activities',
  label: 'কার্যক্রম',
  icon: ListChecks
}, {
  id: 'profile',
  label: 'প্রোফাইল',
  icon: User
}];
export function BottomNav({
  current,
  go
}: {
  current: OfficerScreen;
  go: (s: OfficerScreen) => void;
}) {
  return <nav className="grid shrink-0 grid-cols-4 border-t border-border bg-white pb-1" aria-label="অ্যাপ নেভিগেশন" data-id="element-351" data-mp="2fnebi3ux33ta">
      {items.map(it => {
      const Icon = it.icon;
      const active = current === it.id;
      return <button key={it.id} onClick={() => go(it.id)} className={`flex flex-col items-center gap-0.5 py-2 text-[11px] ${active ? 'font-semibold text-[#003B71]' : 'text-slate-500'}`} data-id="element-352" data-mp="2pglddeqg81om">
            <Icon className="h-5 w-5" data-id="element-353" data-mp="2zau5407nnqlq" />
            {it.label}
          </button>;
    })}
    </nav>;
}